export const TrackEventCategory = {
  Navigation: "Navigation",
};

export const TrackEventNavigationAction = {
  Click: "Click on main menu",
};
